// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".attachments-border[data-v-4504c31a]{border:1px solid #d3d3d3;border-spacing:2px}.attachments[data-v-4504c31a]{margin-top:.5rem}.order-attachments-grid[data-v-4504c31a]{display:grid;grid-template-columns:repeat(2,1fr);gap:1rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
